import { BlogSection } from '@/types/blog';

export const airdropsSection: BlogSection = {
  id: 'airdrops',
  title: 'Airdrops und Hard Forks – Überraschende Zuwendungen',
  content: `
    <p>
      Der Krypto-Markt kennt einzigartige Phänomene, die steuerliche Fragen aufwerfen:
    </p>

    <ul>
      <li><strong>Airdrops:</strong> Erhältst du Kryptowährungen kostenlos im Rahmen von Marketing-Aktionen, könnte dies als steuerpflichtiges Einkommen gelten – insbesondere wenn du dafür aktiv etwas tun musstest, wie Social-Media-Beiträge verfassen.</li>
      <li><strong>Hard Forks:</strong> Bei einer Blockchain-Aufspaltung erhältst du oft neue Coins. Das BMF sieht hier erst beim Verkauf der neuen Coins eine steuerliche Relevanz, wenn dieser innerhalb eines Jahres nach Erhalt erfolgt.</li>
    </ul>
  `
};
